import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Star from "../images/star.png";
import Elon from "../images/Elon.jpg";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import AlienWorlds from "../images/AlienWorlds.jpg";
import ProfileTweet from "../images/profileTweet.jpg";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Retweet from "../images/retweet.png";
import LabTabs from "./tabs";
import Avatar from "@mui/material/Avatar";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import GifBoxOutlinedIcon from "@mui/icons-material/GifBoxOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import SentimentSatisfiedAltOutlinedIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SwipeableTemporaryDrawer from "../MobileDrawer";
import VerifiedIcon from "@mui/icons-material/Verified";
import "../styles/Home.css";
import Tweets from "../Datas/data";
import Profile from "../images/profile.jpg";
import Trending from "../Datas/Trending";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Tofollow from "../Datas/Tofollwo";
import ButtonAppBar from "../Appbar";
import Box from "@mui/material/Box";
import Foryou from "../images/foryou.jpeg";
import { styled } from "@mui/material/styles";
const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "light" ? "#fff" : "grey[800]"
}));

const Puller = styled(Box)(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === "light" ? "grey[300]" : "grey[900]",
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)"
}));

export default function TweetsForyouTemplate(props) {
  var datas = props.datas.tweets;
  const Banner = props.datas.headlines.img.Foryou;
  const subTitle = props.datas.headlines.subTitle;
  const Title = props.datas.headlines.Title;
  var lastTweet = Tweets.length - 1;
  var ls = datas.length - 1;
  console.log(ls);
  const [isMobile, setIsMobile] = useState(false);
  function IsMobileQuery() {
    useEffect(() => {
      const media = window.matchMedia("(min-width: 500px)");
      const listener = () => setIsMobile(media.matches);
      listener();
      window.addEventListener("resize", listener);

      return () => window.removeEventListener("resize", listener);
    }, [isMobile]);

    return <div className="App">{isMobile ? null : null}</div>;
  }
  return (
    <div>
      {Banner && subTitle ? <div
        class="container "
        style={{
          position: "relative",
          textAlign: "center",
          color: "white",
          marginLeft: "-12px",
          paddingBottom: "8px",
          marginTop: "-17px",
          width: "fit-content"
        }}
      >
        <img
       
          src={Banner}
          alt="Snow"
          style={{ width: isMobile ? "106%" : "104%" }}
        />
        <div
          class="bottom-left"
          style={{
            position: "absolute",
            bottom: isMobile ? Title.length <50?"60px":"102px" : Title.length <40 ? "50px":"70px",
            left: isMobile ? "37px" : "37px",
            fontSize: "smaller"
          }}
        >
          {subTitle}
        </div>
        <div
          class="bottom-left "
          style={{
            position: "absolute",
            bottom: "30px",
            width: !isMobile? "353px": "auto",
            left: "36px",
            fontSize: isMobile ? "x-large" : "smaller",
            textAlign: "left",
            fontWeight: "600"
          }}
        >
          {Title}
        </div>
      </div>: <h6 style={{marginLeft: "31px", fontWeight: "600", marginBottom: !isMobile?"15px": "0px", fontSize: "19px"}}>India trends</h6>}
      
      <IsMobileQuery />
      {datas.map((tweet, index) => (
        <div
          style={
            isMobile
              ? {
                  paddingTop: index === 0 ? "6%" : "2%",
                  marginTop: index === 0 ? Banner ? "-39px": "7px" : "-17px"
                }
              : {
                  paddingTop: index !== 0 ? "5px" : Banner ? "2%" : "7%",
                  marginTop: index === 0 ? "-10px" : "-17px"
                }
          }
          className="tweet"
        >
          <div
            style={{
              marginLeft: "18px",
              marginTop: index === 0 ? Banner ?"7px": "-20px":"-1px",
              display: "flex",
              marginBottom: index === lastTweet && !isMobile ? "20px" : "-20px"
            }}
          >
            <div
              style={index === ls ?{
                padding: "5px",
                marginLeft: "10px",
                width: "100%",
                marginTop: "-6px",
                marginBottom: !isMobile && tweet.disImage ? "-10%" : "30px"
              }: {
                padding: "5px",
                marginLeft: "10px",
                width: "100%",
                marginTop: "-6px",
                marginBottom: !isMobile && tweet.disImage ? "-10%" : "11px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "23px",
                  justifyContent: "space-between"
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    marginLeft: "0%",
                    marginTop: "3px",
                    opacity: "0.7"
                  }}
                >
                  {tweet.subhead}
                </p>
                {tweet.img?
                <Avatar
                alt="Remy Sharp"
                src={tweet.img.RIPLEGEND}
                style={tweet.title.length>20? { borderRadius: "20%", marginRight: "6%",marginTop: isMobile? "0%" : "3%" }: {borderRadius: "20%", marginRight: "6%"}}
                sx={{ width: 80, height: 80 }}
              />
                : <MoreHorizOutlinedIcon style={{ marginTop: "3px", marginRight: "5px" }} />}
                
              </div>
              <p
                style={{
                  fontSize: "14px",
                  marginTop: "0px",
                  width: isMobile && tweet.img?  "90%": "60%",
                  fontWeight: "600",
                  paddingBottom: !tweet.nooftweets && !tweet.img ? "20px": "0px"
                }}
              >
                {tweet.title}
              </p>
              <p
                style={{
                  fontSize: "13px",
                  marginLeft: "0%",
                  marginTop: "-15px",
                  opacity: "0.7",
                 
                }}
              >
                {tweet.nooftweets}
              </p>
            </div>
          </div>

          <hr style={tweet.nooftweets?{ marginTop: tweet.img? "10px" : "0px", opacity:  Banner ? "0": "0" }:{ marginTop: tweet.title.length < 10 ? tweet.img? "25px" : "0px" : tweet.img? "50px" : "0px" , opacity: "0" }} />
        </div>
      ))}
    </div>
  );
}
